import React from "react";
import { RegistrationForm } from "components/RegistrationForm";

import "./style.scss";

export const DetailsForm = ({labels}) => {
    return (
        <>
            <RegistrationForm values={labels} />
        </>

    )
}